import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  Box,
  Button,
  PageTitle,
  Tabs,
  Grid,
  Loader,
  Text,
  StatusIndicator,
} from "@flexisaf/flexibull2";
import ExamGroupEditor from "../exam-groups/support/examGroupEditor";
import useSingleExamGroupGet from "../../hooks/exam-groups/useSingleExamGroupGet";
import styled from "styled-components";
import Theme from "../../theme";
import ExamsTab from "./tabs/examsTab";
import WAECLOGO from "../../assets/waeclogo.png";
import { getUrlParam } from "../../utils/helpers";
import TagsTab from "./tabs/tagsTab";

export const DetailsCard = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 2rem;
  padding: 1rem 0;
`;

const ExamGroup = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [reloadTabs, setReload] = useState(false);
  const tab = getUrlParam("activeTab");
  const { id } = useParams();

  const { groupData } = useSingleExamGroupGet({
    id,
  });

  const [modal, setModal] = useState({
    show: false,
    data: null,
  });

  const handleReload = () => {
    setReload(true);
    setTimeout(() => {
      setReload(false);
    }, 1000);
  };

  useEffect(() => {
    if (tab) {
      setActiveTab(parseInt(tab));
      handleReload();
    }
  }, [tab]);

  const handleEdit = () => {
    setModal({ show: true, data: groupData });
  };

  const closeModal = () => {
    setModal({ show: false, data: null });
  };
  return (
    <Box>
      <PageTitle>
        <i className="saf-clipboard-text" />
        <Text bold size={Theme.H3} style={{ padding: "0 10px" }}>
          Exams
        </Text>
      </PageTitle>
      {id && groupData && (
        <Box>
          <Grid default="2fr 2fr 1fr">
            <DetailsCard>
              {" "}
              <img
                src={groupData?.imageUrl ? groupData?.imageUrl : WAECLOGO}
                width="50px"
                height="50px"
                alt="exam-logo"
                style={{ borderRadius: "50%" }}
              />
              <Box>
                <Text size="1.2rem">{groupData?.name}</Text>
                <p>{groupData?.description}</p>
              </Box>
              <Box>
                <StatusIndicator
                  compound
                  label={groupData?.active ? "Active" : "Inactive"}
                  color={
                    groupData?.active ? Theme.PrimaryGreen : Theme.PrimaryRed
                  }
                />
              </Box>
            </DetailsCard>
            <Box />
            <Box>
              <Button pale block onClick={handleEdit}>
                Edit Group Information
              </Button>
            </Box>
          </Grid>
        </Box>
      )}

      <Box pad="1rem 0">
        {reloadTabs ? (
          <Box pad="150px 0">
            <Loader color={Theme.PrimaryColor} section />
          </Box>
        ) : (
          <Tabs
            activeTab={activeTab}
            padContent="35px 0 0 0"
            bgColor={Theme.PrimaryFade}
          >
            <Box label="Exams">
              <ExamsTab />
            </Box>
            <Box label="Tags">
              <TagsTab />
            </Box>
          </Tabs>
        )}
      </Box>

      <ExamGroupEditor
        open={modal.show}
        data={modal.data}
        cbProps={{ refetchGroup: true, refetchGroups: false }}
        closeModal={closeModal}
      />
    </Box>
  );
};

export default ExamGroup;
